module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Gb-Ha 后背.60fb5862.png";